module.exports = __webpack_public_path__ + "img/website-service-07.be97e99b.png";